module.exports = __webpack_public_path__ + "officialStatic/img/case4.242b6c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/case4.png
// module id = WKm5
// module chunks = 0